import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/main.css';
import PageBannerImage from '../Images/ISC-PropEx-BG-Image.jpg';
import PropertyScreeningImage from "../Images/ISC-PropEx-PropertyScreening.png";
import PlotImage from "../Images/Plot.jpeg";
import {appendScript} from '../scriptAdded';

export const ListingBanner = () =>{
    return(
        <div className="jumbotron" style={{backgroundImage:`url(${PageBannerImage})`,backgroundSize:"cover"}}>
            <div className="container">
                <div className="row">
                    <div className="col-md-7 col-lg-7">
                        <h4 className="banner-title">Do you want to  <span>buy or sell a property</span> using ISC Realty ?</h4>
                            <p>ISC Realty is one of the top channel partners for many real estate companies and we also deal with individual properties, commercial and residential, land or built up spaces.</p>
                            <p>Contact our agents to list your property here for sales related queries. We only list mandated properties to us.</p>
                            <a class="btn btn-primary btn-lg" href="#propertyExchange" role="button">Know More</a>
                        
                    </div>
                    <div className="col-md-5 col-lg-5">
                        <img src={PropertyScreeningImage} alt="PropertyImage" style={{width:"100%"}} />
                    </div>
                </div>
            </div>
        </div>
        

    )
}
export const PropertyLisitingContext = () =>{
    const [PropertyData,setPropertyData]=useState({listData:[]});
    useEffect(()=>{
        
        axios.get('https://internationalstrategicconsultants.com/iscPropExApi/propertyList.php').then(res=>{
                   setPropertyData({
                       ...PropertyData,
                       listData:res.data

                   })
                   console.log(res);
                  
        })
    });
    return(
        <section className="">
            <div className="container">
                <div className="row spacing-border-top">
                    <div className="col-md-5 col-lg-5">
                        <h4 className="banner-title">Property<br/>
                        <span>Listing</span></h4>
                    </div>
                   

                </div>
                <div className="row" style={{marginTop:"40px",marginBottom:"40px"}}>
                    {
                        PropertyData.listData.map((result) =>{
                            var propertyImages=result.PropertyImages.split(',');
                            
                            return(
                            <div className="col-md-4 col-lg-4 propertyLisitingSpace">
                           
                                <div id={"carouselExampleIndicators" +result.id} className="carousel slide PropertyListSliding" data-ride="carousel">

                                    <div className="carousel-inner">
                                    {
                                    propertyImages.map((Images,index) =>{
                                        console.log(index)
                                        let active='';
                                        if(index===0){
                                            active='active'
                                        }
                                        
                                        return(
                                            Images ?
                                                <div className={"carousel-item "+active} id={index}>
                                                    <img src={'https://internationalstrategicconsultants.com/iscPropExApi/uploads/'+Images} className="d-block w-100" alt="..." style={{height:"250px"}}  />
                                                </div>
                                                : null
                                                    )
                                                    
                                            })
                                        }
                                    
                                    </div>
                                    <a className="carousel-control-prev" href={"#carouselExampleIndicators"+result.id} role="button" data-slide="prev">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                    <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="carousel-control-next" href={"#carouselExampleIndicators"+result.id} role="button" data-slide="next">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <span className="sr-only">Next</span>
                                    </a>
                                </div>
                                <div className="pricePlot">
                                    <span className="PlotPrice">Rs.{result.total}</span>
                                </div>
                                <div className="PlotList-Villa-Content">
                                    <h4><Link to={process.env.PUBLIC_URL+'/property-list/' + result.Name} className="PlotList-Villa-Title">{result.Name}</Link></h4>
                                    {
                                        /* <Link to={{
                                            pathname:"property-list-details",
                                            id:`${result.id}`
                                            
                                            }} className="PlotList-Villa-Title">{result.Name}</Link></h4>
                                        */
                                    }
                                    <p>{result.propertyType}</p>
                                    <div className="row">
                                    {result.squareYard ?
                                        <div className="col-7">
                                            <h4 className="PlotList-Villa-Sqyards">{result.squareYardsData}<br/>
                                            <span>{result.squareYard}</span></h4>
                                        </div>
                                        : result.PriceSquareFeet ?
                                        <div className="col-5">
                                            <h4 className="PlotList-Villa-Sqyards">Price Sq.Yds<br/>
                                            <span>{result.PriceSquareFeet}</span></h4>
                                        </div>
                                        : null
                        }
                                    </div>
                                    {
                                        result.location ?
                                        <h4 className="Plot-Product-title">Location: {result.location}</h4>
                                        : null
                                    }
                                    
                                </div>
                            </div>
                            );
                        })
                    }
                    
               
                </div>
            </div>
        </section>
    )
}